import { BaseAuthenticator } from './base-authenticator.js';
import { appendHeaders } from './helpers.js';
export class BearerAuthenticator extends BaseAuthenticator {
    constructor(url, bearer) {
        super('bearer');
        this.bearer = bearer;
        this._resolve(true);
    }
    applyHeaders(headers) {
        const authHeader = 'Bearer ' + this.bearer;
        appendHeaders(headers, { Authorization: authHeader });
    }
    authenticate() {
        // TODO: implement authentication test
        return this._result;
    }
    authenticated() {
        return this._result;
    }
}
/**
 * Checks if an authenticator is a BearerAuthenticator.
 *
 * @param authenticator - The authenticator to check.
 * @internal
 */
export function isBearerAuthenticator(authenticator) {
    return authenticator.type === 'bearer';
}
//# sourceMappingURL=bearer-authenticator.js.map